/* src/app/order/components/order-pricing/price-card/price-card.style.scss */
.nb-card-border {
  border-color: #007d40;
  border-width: 2px;
}
nb-card {
  max-width: 230px !important;
  min-width: 220px !important;
}
nb-card nb-card-header.header {
  padding: 19px 20px 4px 20px !important;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #585858;
  border-bottom: 1px solid #cccccc !important;
}
nb-card nb-card-body {
  padding: 0 0 26px 0 !important;
}
nb-card nb-card-body .audit-pricing {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
}
nb-card nb-card-body .audit-pricing .price-box:not(.fee) + .price-box.fee {
  margin-top: 15px;
}
nb-card nb-card-body .audit-pricing .price-box:not(.fee) {
  margin-top: 15px;
}
nb-card nb-card-body .audit-pricing .price-box > div {
  display: flex;
  justify-content: space-between;
}
nb-card nb-card-body .audit-pricing .price-box .audit-type {
  padding: 0 !important;
  margin-right: 5px;
}
nb-card nb-card-body .audit-pricing .price-box .audit-type label {
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  color: #007d40;
}
nb-card nb-card-body .audit-pricing .price-box .price {
  padding: 0 !important;
  margin-left: 5px;
  text-align: right;
}
nb-card nb-card-body .audit-pricing .price-box .price span {
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  text-align: right;
  color: #585858;
}
nb-card nb-card-body .audit-pricing .price-box .audit-days {
  padding: 0 !important;
}
nb-card nb-card-body .audit-pricing .price-box .audit-days span {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #585858;
}
nb-card nb-card-body .audit-pricing .price-box .fee-label {
  padding: 0 5px 0 0;
}
nb-card nb-card-body .audit-pricing .price-box .fee-label span {
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  color: #585858;
}
nb-card nb-card-body .audit-pricing .price-box .audit-onsite-days {
  font-size: 12px;
}
nb-card nb-card-body .audit-pricing .total-price-box {
  margin-top: 20px !important;
}
nb-card nb-card-body .audit-pricing .total-price-box .total-price {
  padding: 0 !important;
  text-align: right;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: #007d40;
}
nb-card nb-card-body .audit-pricing .total-price-box .total-price.first-year span {
  font-size: 22px;
}
nb-card nb-card-body .audit-pricing .total-price-box .total-price:not(.first-year) span {
  font-size: 18px;
}
@media screen and (max-width: 1279px) {
  nb-card {
    max-width: unset !important;
    min-width: unset !important;
  }
}
/*# sourceMappingURL=price-card.style.css.map */
